<template>
  <div>
    <div class="header-width divcss5">
      <productdetailbanner></productdetailbanner>
    </div>
    <div class=" row body-width divcss5">
      <hhxnsxxheader></hhxnsxxheader>
    </div>
    <div class=" row body-width divcss5">
      <router-view />
    </div>
  </div>
</template>
<script>
  import productdetailbanner from "@/components//contentcoms/prodecutcontentcoms/productdetailbanner";
  import hhxnsxxheader from "@/components/contentcoms/prodecutcontentcoms/hhxnsxxlcp/hhxnsxxheader";


  export default {
    name: "producthhxnsx",
    components: {
      productdetailbanner,
      hhxnsxxheader,
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/producthhxnsx.vue